import React from "react";

const About = () => {
  return (
    <section className="section about">
      <h2 className="section-header menu-header">About Us</h2>
      <article className="section-group">
        <h2>Our History</h2>
        <p>
          Affordable services was established in December 2015 in Lagos. It is
          an organization that tailored cooking to suite client's desire. We are
          organisation which match the tastes of guest based on exceptional and
          hygienic food preparation. We make foods for events such as dinners
          parties, kiddies parties, office parties, birthday parties, school
          reunions, friends hangouts, funeral parties and wedding parties with
          an assortment in nourishment from various foods.
        </p>
      </article>
      <article className="section-group">
        <h2>Our Mission</h2>
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Culpa
          eligendi non minus tenetur ab eum at maiores, id nisi, modi
          repellendus libero rerum, a aut laboriosam nam ullam hic sequi!
          Quaerat quod enim dolorem molestiae expedita distinctio porro,
          pariatur optio a beatae iste at aperiam consectetur mollitia in
          similique n.
        </p>
      </article>
      <article className="section-group">
        <h2>Our CEO</h2>
        <img src="/images/oga.jpeg" alt="The CEO" />
        <p>
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Culpa
          eligendi non minus tenetur ab eum at maiores, id nisi, modi
          repellendus libero rerum, a aut laboriosam nam ullam hic sequi!
          Quaerat quod enim dolorem molestiae expedita distinctio porro,
          pariatur optio a beatae iste at aperiam consectetur mollitia in
          similique n.
        </p>
      </article>
    </section>
  );
};

export default About;
